import React from 'react';
import _ from 'lodash';
import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../common/form';
import Progress from '../themed/progress';

import * as service from '../../services/facilityService';
import * as toastService from '../../services/toastService';

import * as models from '../../utils/models';
import * as utils from '../../utils/utilities';

import withCountries from '../hoc/withCountries';
import withOrganizations from '../hoc/withOrganizations';

import routes from '../../utils/routes';

class UpdateFacility extends Form {
	state = {
		data: {
			facilityLogo: [],
			facilityName: '',
			organisationId: '',
			country: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		facilityLogo: Joi.array().min(0).required().label('Facility Logo'),
		organisationId: Joi.string().min(3).required().label('Organization'),
		facilityName: Joi.string().min(3).required().label('Facility Name'),
		country: Joi.string().min(3).required().label('Country'),
	};

	static propTypes = {
		facility: PropTypes.object,
	};

	async componentDidMount() {
		await this.resetFacility();
	}

	resetFacility = (): void => {
		const facility: models.Facility | null = this.props.facility;
		if (!facility) return;

		this.setState({
			data: {
				facilityLogo: [
					{
						refNo: 1,
						format: 'jpg',
						src: facility.facilityLogo,
						caption: facility.facilityName,
					},
				],
				facilityName: facility.facilityName,
				organisationId: facility.organisationId,
				country: facility.facilityLocation.country,
			},
		});
	};

	getApiData = () => {
		const { data } = this.state;

		const apiData: any = { facilityName: data.facilityName };
		apiData.facilityLocation = _.pick(data, ['country']);

		const newFacilityLogo = data.facilityLogo[0] as models.PDFImageProps;

		if (newFacilityLogo) apiData.facilityLogo = newFacilityLogo.src;
		else delete apiData.facilityLogo;

		return apiData;
	};

	postData = async (): Promise<void> => {
		const facility: models.Facility | null = this.props.facility;
		if (!facility) return;

		const apiData = this.getApiData();
		await service.updateFacility(facility._id, apiData, this.handleProgressChange);

		window.location.href = routes.organizations.fullPath;
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Updating Facility',
			success: 'Facility Updated',
			error: utils.getErrorMessage,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
					<h1 className="form-title">Update Facility Details</h1>

					{this.renderFileInput({
						max: 1,
						multiple: false,
						name: 'facilityLogo',
						accept: 'image/*,application/pdf',
						label: 'Facility Logo',
						sublabel: 'Upload Facility Logo',
						types: utils.getFileUploadTypes(),
					})}

					<div className="divider my-4"></div>

					<div className="row mt-2">
						<div className="col">
							{this.renderSelect({
								name: 'organisationId',
								label: 'Organization',
								placeholder: 'Select an Organization',
								disabled: true,
								options: this.props.organizationsForDropdown,
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'facilityName',
								label: 'Facility Name',
								placeholder: 'Enter Facility Name',
							})}
						</div>
					</div>

					<div className="divider my-4"></div>

					<div className="row mt-2">
						<div className="col">
							{this.renderSelect({
								name: 'country',
								label: 'Country',
								placeholder: 'Select Country',
								options: this.props.countries,
							})}
						</div>
					</div>

					<div className="d-flex justify-content-end">
						{this.renderButton('Update')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default withOrganizations(withCountries(UpdateFacility));
